<template>
    <div class="rr-box">
        <ReumTextBox class="input-text rr-text" label="Sample Script" v-model="comp.info.text"></ReumTextBox>
        <button v-if="comp.info.status==0" class="btn-rec" @click="comp.onRecord"><i class="las la-microphone"></i></button>
        <button v-if="comp.info.status==1" class="btn-rec">...</button>
        <button v-if="comp.info.status==2" class="btn-rec" @click="comp.onStop"><i class="las la-stop"></i></button>
        <audio id="audioplayer" class="rr-voice" :src="comp.info.mergeURL" controls></audio>
        <button class="btn-audio" @click="comp.onPlay('')" :class="{ 'active':comp.info.mergeURL!=null }"><i class="las la-play"></i></button>
        <button v-if="comp.info.mergeURL!=null" class="btn-send" @click="comp.onSend"><i class="lar la-paper-plane"></i> Send to Server</button>
    </div>
    <div class="bar"><span>pronunciation list</span></div>
    <div class="sample-list">
        <div class="sample-item"><div class="title">Touch or Click script text.</div></div>
        <template v-for="(irow, i) in comp.list" :key="i">
            <div class="sample-item" :class="{ 'selected':comp.selected.idx==irow.idx }">
                <div>
                    <span class="script" @click="comp.doSelect(irow)">{{ irow.script }}</span>
                    <div class="pronunciation">
                        <ReumTextBox class="input-text rr-text" :label="irow.script" v-model="comp.selected.pron"></ReumTextBox>
                        <button class="btn-submit" @click="comp.doSubmit()"><i class="las la-save"></i></button>
                        <button class="btn-cancel" @click="comp.doDeselect()"><i class="las la-ban"></i></button>
                        <button class="btn-help" @click="comp.howUse()"><i class="las la-question"></i></button>
                    </div>
                </div>
                <button class="btn-play" @click="comp.onPlay(irow)" :class="{ 'play':comp.play.idx==irow.idx }"><i class="las la-play"></i></button>
                <button type="button" class="btn-del" @click="comp.doDelete(irow.idx)"><i class="lar la-trash-alt"></i></button>
            </div>
        </template>
    </div>
    <audio id="audioplayer2" class="rr-voice" :src="comp.play.vpath"></audio>
    <div class="modal" :class="{ 'open':comp.is_pop_help=='Y' }">
        <div class="modal-close" @click="comp.howUse()"></div>
        <div class="modal-pop">
            <div class="close" @click="comp.howUse()"><i class="lar la-times-circle"></i></div>
            <div class="modal-body">
                발음기호를 쓰시고, 해당 문장을 운율과 음운 단위로 구분하여 '|'로 나눠 주십시오.<br>강하게 발음하는 부분은 대문자로 써 주시면 됩니다.<br>
                <div class="ex-box">
                    <div class="tit">[example]</div>
                    <div>from fairest creatures we desire increase</div>
                    <div>from|FAI|rest|CREA|tures|WE|de|SIRE|in|CREASE</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { reactive, onMounted, ref } from "vue";
import axios from "axios";
import { useToast } from 'vue-toastification';
import ReumTextBox from "@/components/ReumLib/UI/ReumTextBox.vue";

export default {
    name: "List",
    props: {
        modelValue: String,
    },
    components: {
        ReumTextBox
    },
    setup(props) {
        const editor = ref(null);
        const toast  = useToast();
        const comp = reactive({
            audioplayer : null,
            info: {
                text:"",
                status: 0,
                chunks: [],
                mergeURL: null,
                source:null,
                base64: null,
            },
            rec_config: {
                audio: true,
                // {
                //     channelCount: 1,
                //     sampleRate: 16000,
                //     sampleSize: 16,
                //     volume: 1
                // },
                video:false
            },
            recorder : null,
            list:[], total:0,
            play: { idx:'', vpath:"" },
            selected: { idx:'', pron:'' },
            is_pop_help: 'N',

            gotStream: (mediaStream) => {
                console.info("gotStream");
                comp.info.status = 2;
                window.streamReference = mediaStream;
                comp.recorder = null;
                comp.recorder = new MediaRecorder(mediaStream);
                comp.recorder.start(100);
                comp.recorder.ondataavailable = comp.audioDataHandler;
            },
            onRecord: () => {
                console.info("Record");
                comp.info.status = 1;
                comp.info.chunks = [];
                navigator.mediaDevices.getUserMedia(comp.rec_config)
                .then(comp.gotStream)
                .catch(err => {
                    console.error(err.name + ": " + err.message)
                    toast.error(err.name + ": " + err.message)
                    comp.info.status = 0;
                });
            },
            onStop: () => {
                console.info("Stop");
                comp.info.status = 3;
                if (!window.streamReference) {
                    return;
                }
                window.streamReference.getAudioTracks().forEach(track => {
                    track.stop();
                });
                window.streamReference = null;

            },
            onSend: () => {
                let params = {
                    text:comp.info.text,
                    raw:comp.info.base64
                }
                if( !params.text ){
                    toast.warning("스크립트를 입력하세요.")
                    return
                }
                axios.post("/ai/sample_upload", params).then((res) => {
                    if(res.data.err == 0) {
                        comp.info.text = ""
                        comp.info.base64 = null
                        comp.info.mergeURL = null
                        toast.success("전송했습니다.");
                        comp.doSearch()
                    } else {
                        if( res.data.err_msg ) toast.error(res.data.err_msg);
                    }
                }).catch((err) => {
                    toast.error("연결에 오류가 있습니다. :: ", err);
                });
            },
            audioDataHandler(event){
                console.info("Push");
                comp.info.chunks.push(event.data);
                if(comp.info.status == 3) {
                    let mergeBlob = new Blob(comp.info.chunks,{type:'audio/wav; codecs=MS_PCM'})
                    comp.info.mergeURL = URL.createObjectURL(mergeBlob);

                    let reader = new FileReader();
                    reader.onload = function(event){
                        comp.info.base64 = event.target.result;
                    }; // data url!
                    comp.info.source = reader.readAsDataURL(mergeBlob);
                    comp.info.status = 0;
                }
            },
            onPlay:(o) => {
                // comp.audioplayer.volume = 0.2;
                // comp.audioplayer.loop = true;
                if( o ){
                    comp.play.idx = o.idx
                    comp.play.vpath = o.vpath
                    let audioplayer = document.getElementById("audioplayer2")
                    setTimeout(() =>{
                        audioplayer.play();
                    }, 200)
                    
                } else {
                    comp.play.idx = 0
                    comp.play.vpath = ""
                    comp.audioplayer.play();
                }
            },

            doSearch: () => {
                let params = {
                    page : comp.page
                }
                axios.get("/ai/sample_list", { params:params }).then((res) => {
                    if( res.data.err == 0 ){
                        comp.list = res.data.list
                        comp.total = res.data.total
                    }
                })
            },

            doSelect:(s)=>{
                comp.selected.idx = s.idx
                comp.selected.pron = s.pronunciation
            },

            doDeselect:()=>{
                comp.selected.idx = ''
                comp.selected.pron = ''
            },

            doSubmit: () => {
                let params = {
                    idx : comp.selected.idx,
                    pron : comp.selected.pron
                }
                if( !params.pron || !(params.pron.trim()) ){
                    toast.warning("발음기호를 입력해 주세요.")
                    return;
                }
                axios.post("/ai/sample_pron", params).then((res) => {
                    if( res.data.err == 0 ){
                        comp.doSearch()
                        comp.doDeselect()
                    } else {
                        if( res.data.err_msg ) toast.error( res.data.err_msg )
                    }
                });
            },

            doDelete:(idx)=>{
                let params = { idx:idx }
                if( confirm("삭제하시겠습니까?") == true ){
                    axios.get("/ai/sample_del", { params:params }).then((res) => {
                        if( res.data.err == 0 ){
                            comp.doSearch()
                        } else {
                            if( res.data.err_msg ) toast.error( res.data.err_msg )
                        }
                    })
                }
            },

            howUse: () => {
                if( comp.is_pop_help == 'Y' ){
                    comp.is_pop_help = 'N'
                } else {
                    comp.is_pop_help = 'Y'
                }
            }

        });
        onMounted(() => {
            comp.val = props.text;

            comp.audioplayer = document.getElementById("audioplayer")

            comp.doSearch()
        });
        return { comp, editor, props };
    }
}
</script>

<style lang="scss">
    @import "@/scss/_variables.scss";

    .rr-box {
        padding:10px 20px;

        .rr-text {
            width:calc(100% - 90px); float:left;
        }
        .rr-voice {
            width:1px; height:1px; opacity:0.01;
        }
        .btn-rec {
            width:40px; height:40px; padding: 3px 0px;color: #FFF; margin-top:10px;
            background-color: rgb(238, 122, 122); border: 1px solid #ddd; border-radius: 50%; font-size:1.4rem; text-align:center;
        }
        .btn-audio {
            width:40px; height:40px; padding: 3px 10px;color: #FFF; margin-top:10px;
            background-color:#d0d0d0; border: 1px solid #ddd; border-radius: 50%;
            font-size:1.4rem; text-align:center;
            &.active {
                background-color:rgba(177, 214, 129, 0.7);
            }
        }
        .btn-send {
            width:100%; height:40px; padding: 3px 10px; margin-top:5px;
            background-color: rgb(122, 134, 238); color: #FFF;
            border: 1px solid #ddd; border-radius: 50px;
        }
    }
    .bar {
        position:relative; height:20px; padding:10px 0px; border-top:1px solid #c8c8c8; margin:20px 20px 0;
        span {
            position:absolute; top:-10px; left:0; right:0; width:130px; margin:0 auto; text-align:center; background-color:#f9f9f9; color:#999;
        }
    }

    .sample-list {
        padding:0 20px;
        .sample-item {
            position:relative; margin-bottom:5px; border-bottom:1px solid #c8c8c8; padding-bottom:5px;
            .title {
                display:block; text-align:left; height:inherit; color:#929292;
            }
            > div {
                position:relative;
                width:calc(100% - 100px); height:40px; text-align:left; vertical-align:middle;
                display:flex;justify-content: center; align-items: center;
                .script {
                    position:absolute; left:0; vertical-align:middle; cursor:pointer;
                }
                .pronunciation {
                    position:relative; display:none; width:100%; height:40px; text-align:left;
                    .reum-textbox {
                        width:calc(100% - 140px); margin-top:-9px; display:inline-block;
                    }
                    > button {
                        display:inline-block; width:40px; height:40px; 
                        padding:0; background-color:rgba(177, 214, 129, 0.7); border: 1px solid #ddd; border-radius: 50%;
                        color: #FFF; font-size:1.4rem; text-align:center; margin-top:-1px;
                    }
                    .btn-submit {
                        background-color:rgb(132, 196, 49);
                    }
                    .btn-cancel {
                        background-color: rgb(240, 48, 48);
                    }
                    .btn-help {
                        background-color: rgb(204, 204, 204);
                    }
                }
            }
            .btn-play {
                position:absolute; top:0; right:50px;
                width:40px; height:40px; padding: 3px 10px;color: #FFF;
                background-color:rgba(177, 214, 129, 0.7); border: 1px solid #ddd; border-radius: 50%;
                font-size:1.4rem; text-align:center;
            }
            .btn-del {
                position:absolute; top:0; right:0px;
                width:40px; height:40px; padding: 3px 0px;
                background-color: rgb(255, 81, 81); color: #FFF;
                border: 1px solid #ddd; border-radius: 50px; font-size:1.4rem; text-align:center;
            }
            &.selected {
                .script {
                    display:none;
                }
                .pronunciation {
                    display:block;
                }
            }
        }
    }

    .modal {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        width: 100%;
        height: 100%;
        z-index: 999;
        background: rgba(0,0,0,.3);
        display: none;
        flex-flow: column wrap;
        justify-content: center;
        align-items: center;
        opacity:0;
        transition : all 0.5s;
        &.open {
            display: flex; opacity:1;
            .modal-close {
                position: absolute;
                z-index: 3;
            }
        }
        &-close {
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            width: 100%;
            height: 100%;
            cursor:pointer;
        }
        &-pop {
            z-index: 5;
            background: #fff;
            border-radius: 4px;
            width: 100%;
            max-width: 500px;
            min-height: 100px;
            padding:30px;
            position:relative;
            .close {
                position:absolute; top:-12px; right:-14px; width:20px; height:20px; border-radius:20px; cursor:pointer;
            }
        }
        &-body {
            text-align:left;
            .ex-box {
                margin-top:20px; word-break: break-all;
                font-size:1rem; color:#666; text-align:left; padding:20px 10px 10px; border:1px solid #c8c8c8;
            }
        }
    }

</style>